import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';

import { TeamMember } from '../models';

export interface TeamMemberApi {
    message: TeamMember[];
    totalItemCount: number;
    pages: number;
    error: boolean;
}

@Injectable({ providedIn: 'root' })
export class TeamMemberService {
    private _teamMembersRoute = '/api/team-members/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    private _memberToBeViewed: TeamMember = null;

    setMemberToBeViewed(member: TeamMember) { this._memberToBeViewed = member; }
    getMemberToBeViewed(): TeamMember { return this._memberToBeViewed; }

    constructor(
        private httpClient: HttpClient,
        private formBuilder: UntypedFormBuilder
    ) { }

    getAll(): Observable<TeamMember[]> {
        return this.httpClient.get<TeamMember[]>(this._teamMembersRoute);
    }

    getAllActive(): Observable<TeamMember[]> {
        return this.httpClient.get<TeamMember[]>(this._teamMembersRoute + 'active');
    }

    getById(id: string): Observable<TeamMember> {
        return this.httpClient.get<TeamMember>(this._teamMembersRoute + id);
    }

    getNextSortOrder(): Observable<{ sort_order: number }> {
        return this.httpClient.get<{ sort_order: number }>(this._teamMembersRoute + 'next-sort-order');
    }

    search(searchTerms: any): Observable<TeamMember[]> {
        return this.httpClient.post<TeamMember[]>(this._teamMembersRoute + 'search', JSON.stringify(searchTerms), this.headerOptions);
    }

    create(teamMember: TeamMember): Observable<TeamMember> {
        return this.httpClient.post<TeamMember>(this._teamMembersRoute, JSON.stringify(teamMember), this.headerOptions);
    }

    update(teamMember: TeamMember): Observable<TeamMember> {
        return this.httpClient.put<TeamMember>(this._teamMembersRoute + teamMember._id, JSON.stringify(teamMember), this.headerOptions);
    }

    setActive(id: string, active: boolean): Observable<any> {
        return this.httpClient.put<any>(this._teamMembersRoute + 'set-active/' + id, JSON.stringify({ active }), this.headerOptions);
    }

    getCustomDatasource(searchParams: any, sortField = 'name', sortDirection = 'asc', pageNumber: number = 0, pageSize: number = 10): Observable<TeamMemberApi> {
        searchParams['selectAll'] = false;
        searchParams.sortField = sortField;
        searchParams.sortOrder = (sortDirection && sortDirection !== '') ? sortDirection : 'asc';
        searchParams.pageNumber = pageNumber;
        searchParams.pageSize = pageSize;
        return this.httpClient.post<TeamMemberApi>(this._teamMembersRoute + 'dataSourceSearch', JSON.stringify(searchParams), this.headerOptions);
    }


    selectAllSearch(searchTerms: any): Observable<TeamMember[]> {
        searchTerms['selectAll'] = true;
        return this.httpClient.post<TeamMember[]>(this._teamMembersRoute + 'dataSourceSearch', JSON.stringify(searchTerms), this.headerOptions);
    }


    updateSortOrder(members: { _id: string, sort_order: number }[]): Observable<any> {
        return this.httpClient.put<any>(this._teamMembersRoute + 'update-sort-order', JSON.stringify(members), this.headerOptions);
    }

    delete(teamMember: TeamMember): Observable<any> {
        return this.httpClient.delete<any>(this._teamMembersRoute + teamMember._id);
    }

    deleteByIdArray(arrayOfIds: string[]): Observable<any> {
        return this.httpClient.post<any>(this._teamMembersRoute + 'deleteMany', JSON.stringify(arrayOfIds), this.headerOptions);
    }


    teamMemberFormGroup(formData: TeamMember) {
        return this.formBuilder.group({
            name: [formData.name, Validators.required],
            title: [formData.title, Validators.required],
            department: [formData.department],
            active: [formData.active !== undefined ? formData.active : true]
        });
    }
}